export default __webpack_public_path__ + "static/media/Azazel2.ff60a6a9.png";